<template>
    <div>
        <header>
            <div class="banner">
                <van-row>
                    <van-col span="6" @click="back"><img class="back-icon"
                                                         src="@/assets/theme/light/status/01dailyActive/01back.svg">
                    </van-col>
                    <van-col span="12">
                        <div class="banner-title">{{ $t('planEdit.title') }}</div>
                    </van-col>
                    <van-col span="6">
                        <div class="save" @click="addTrainPlan">{{ $t('planEdit.save') }}</div>
                    </van-col>
                </van-row>
            </div>
        </header>
        <div class="content">
            <div class="train-name-box">
                <van-row>
                    <van-col span="12">
                        <div class="plan-name">{{ $t('planEdit.planName') }}</div>
                    </van-col>
                    <van-col span="12">
                        <div class="plan-name-input">
                            <van-field v-model="planDesc.planName" class="plan-name-input-field" input-align="right"
                                       :placeholder="$t('planEdit.planNameDesc')"/>
                        </div>
                    </van-col>
                </van-row>
            </div>
            <div class="action-title">{{ $t('planEdit.action') }} <span class="total-capacity">{{
                    planDesc.totalCapacity
                }} {{ $t('planEdit.capacity') }}</span></div>
            <div class="group-box">
                <div class="group-item" v-for="item in selectedAction">
                    <van-row class="group-top">
                        <van-col span="5">
                            <img class="active-icon" :src="item.bannerUrl">
                        </van-col>
                        <van-col span="19">
                            <div class="flex-line">
                                <div class="action-name" v-if="$i18n.locale === 'en'">{{ item.actionNameEn }}</div>
                                <div class="action-name" v-else-if="$i18n.locale === 'ja'">{{ item.actionNameJa }}</div>
                                <div class="action-name" v-else>{{ item.actionName }}</div>
                                <div class="action-capacity" v-if="item.recordType == 1">{{ item.capacity }}
                                    {{ $t('planEdit.capacity') }}
                                </div>
                            </div>
                            <!--                            <div class="flex-line">-->
                            <!--                                <div class="action-num">2组</div>-->
                            <!--                                <div class="action-omit">···</div>-->
                            <!--                            </div>-->
                            <!--                            <div class="add-top-line">-->
                            <!--                            </div>-->
                            <div class="add-title-box" :class="{'add-title-box-ja':$i18n.locale === 'ja'}"
                                 v-if="item.recordType == 1">
                                <div class="group-title">{{ $t('planEdit.group') }}</div>
                                <div class="w-title">{{ $t('planEdit.weight') }}</div>
                                <div class="f-title">{{ $t('planEdit.frequency') }}</div>
                                <div class="unit-box">
                                    <div class="kg-unit" :class="{'active': item.unit == 'kg'}"
                                         @click="changeUnit(item, 'kg')">kg
                                    </div>
                                    <div class="lbs-unit" :class="{'active': item.unit == 'lbs'}"
                                         @click="changeUnit(item, 'lbs')">lbs
                                    </div>
                                </div>
                            </div>
                            <div class="add-title-box" :class="{'add-title-box-ja':$i18n.locale === 'ja'}"
                                 v-if="item.recordType == 2">
                                <div class="group-title">{{ $t('planEdit.group') }}</div>
                                <div class="w-title">{{ $t('planEdit.duration1') }}</div>
                            </div>
                            <div class="add-title-box" :class="{'add-title-box-ja':$i18n.locale === 'ja'}"
                                 v-if="item.recordType == 3">
                                <div class="group-title">{{ $t('planEdit.group') }}</div>
                                <div class="w-title">{{ $t('planEdit.frequency') }}</div>
                            </div>
                            <div class="add-title-box" :class="{'add-title-box-ja':$i18n.locale === 'ja'}"
                                 v-if="item.recordType == 4">
                                <div class="group-title">{{ $t('planEdit.group') }}</div>
                                <div class="w-title">{{ $t('planEdit.distance') }}</div>
                                <div class="d-unit-box">km</div>
                            </div>
                            <div class="add-line" v-for="(group, index) in item.actionList" :key="index">
                                <div class="add-index">{{ index + 1 }}</div>
                                <div class="add-w-input" v-if="item.recordType == 1">
                                    <van-field class="group-input" type="digit" input-align="center"
                                               v-model="group.w" @blur="forceUpdate" @input="countCapacity(item)"/>
                                </div>
                                <div class="add-f-input" v-if="item.recordType == 1">
                                    <van-field class="group-input" type="digit" input-align="center"
                                               v-model="group.f" @blur="forceUpdate" @input="countCapacity(item)"/>
                                </div>
                                <div v-if="item.recordType == 2">
                                    <van-field class="group-input t1" type="digit" input-align="center"
                                               v-model="group.th"
                                               @blur="validateTimeInput(group, 'th')"/>
                                    <div class="ts1">:</div>
                                    <van-field class="group-input t2" type="digit" input-align="center"
                                               v-model="group.tm"
                                               @blur="validateTimeInput(group, 'tm')"/>
                                    <div class="ts2">:</div>
                                    <van-field class="group-input t3" type="digit" input-align="center"
                                               v-model="group.ts"
                                               @blur="validateTimeInput(group, 'ts')"/>
                                </div>
                                <div class="add-w-input" v-if="item.recordType == 3">
                                    <van-field class="group-input" type="digit" input-align="center"
                                               v-model="group.f" @blur="forceUpdate"/>
                                </div>
                                <div class="add-w-input" v-if="item.recordType == 4">
                                    <van-field class="group-input" type="digit" input-align="center"
                                               v-model="group.d" @blur="forceUpdate"/>
                                </div>
                                <img class="copy-icon" src="@/assets/theme/light/trainPlan/01planEdit/02copy.svg"
                                     @click="copyGroup(item, group)">
                                <img class="delete-icon"
                                     @click="deleteGroup(item, group)"
                                     src="@/assets/theme/light/trainPlan/01planEdit/03delete.svg">
                            </div>
                            <!--                            <div class="time-box" v-if="item.recordType == 2">-->
                            <!--                                {{ $t('planEdit.common') }}-->
                            <!--                                <div class="add-time-input">-->
                            <!--                                    <van-field class="group-input" type="digit" input-align="center"-->
                            <!--                                               v-model="item.actionList[0].c" @blur="forceUpdate"/>-->
                            <!--                                </div>-->
                            <!--                                {{ $t('planEdit.group') }}-->
                            <!--                                <img class="delete-icon"-->
                            <!--                                     @click="deleteGroup(item, item.actionList[0])"-->
                            <!--                                     src="@/assets/theme/light/trainPlan/01planEdit/03delete.svg">-->
                            <!--                            </div>-->
                        </van-col>
                    </van-row>
                    <div class="add-group" @click="addGroup(item)">+1{{
                            $t('planEdit.group')
                        }}
                    </div>
                </div>
            </div>
            <div class="add-action" v-if="selectedAction.length < 10" @click="toActionLibrary">
                <img class="add-icon" src="@/assets/theme/light/trainPlan/01planEdit/01add.svg">
                {{ $t('planEdit.actionAdd') }}
            </div>
        </div>
    </div>
</template>

<script>

import {WebJSBridge} from "../../utils/JSBridge1";

export default {
    name: 'planEdit',
    data() {
        return {
            planId: 0,
            selectedAction: [],
            actionList: [],
            planDesc: {
                planName: '',
                totalCapacity: 0,
                actionList: [],
                actionCount: 0,
                groupCount: 0
            },
            from: '',
            theme: 'light'
        }
    },
    mounted() {
        if (this.$route.query.planId) {
            this.planId = this.$route.query.planId;
            this.getPlanLibraryById();
        }
        if (this.$route.query.from) {
            this.from = this.$route.query.from;
        }
        if (this.$route.query.theme) {
            this.theme = this.$route.query.theme;
        }
    },
    watch: {
        $route(to, from) {
            // 在路由改变时重新加载数据
            let newActionList = JSON.parse(localStorage.getItem('selectedActionList'));
            if (newActionList != null) {
                for (let i = 0; i < newActionList.length; i++) {
                    newActionList[i].capacity = 0;
                    newActionList[i].actionList = [{
                        w: '',
                        f: '',
                        d: '',
                        t: 1800,
                        th: '00',
                        tm: '30',
                        ts: '00'
                    }];
                    newActionList[i].unit = 'kg'
                }
                localStorage.removeItem('selectedActionList')
                // 将这些元素添加到 this.selectedAction 中
                this.selectedAction.push(...newActionList);
            }
            this.$forceUpdate()
        }
    },
    methods: {
        validateTimeInput(group, field) {
            const value = group[field];
            if (value && !/^\d+$/.test(value)) {
                group[field] = value.replace(/[^\d]/g, '');
            }
            if ((field === 'tm' || field === 'ts') && parseInt(group[field]) >= 60) {
                group[field] = '59';
            }
            if (parseInt(group[field]) < 10) {
                group[field] = '0' + parseInt(group[field]);
            }
            if (group[field].length > 2) {
                group[field] = group[field].slice(0, 2);
            }
        },
        forceUpdate() {
            this.$forceUpdate()
        },
        getPlanLibraryById() {
            this.$api.trainPlan.getPlanLibraryById({
                planId: this.planId
            }).then(res => {
                this.planDesc = res.info;
                this.selectedAction = res.info.actionList;
                this.initActionList(res.info)
            })
        },
        initActionList(obj) {
            let actionListGroup = JSON.parse(obj.actionListGroup)
            let actionListUnit = [];
            if (obj.actionListUnit) {
                actionListUnit = obj.actionListUnit.split(',')
            }
            // 将 actionId 字符串解析为数组
            const actionIdArray = obj.actionListId.split(',').map(Number);

            // 根据 actionIdArray 的顺序对 actionList 进行排序
            this.selectedAction.sort((a, b) => {
                return actionIdArray.indexOf(a.actionId) - actionIdArray.indexOf(b.actionId);
            });
            for (let i = 0; i < this.selectedAction.length; i++) {
                this.selectedAction[i].actionList = actionListGroup[i]
                if (actionListUnit.length > 0) {
                    this.selectedAction[i].unit = actionListUnit[i]
                }
                this.selectedAction[i].capacity = 0;
                for (let j = 0; j < this.selectedAction[i].actionList.length; j++) {
                    if (this.selectedAction[i].recordType === 3) {
                        this.selectedAction[i].f = this.selectedAction[i].f + parseInt(this.selectedAction[i].actionList[j].f);
                    }
                    if (this.selectedAction[i].recordType === 4) {
                        this.selectedAction[i].d = this.selectedAction[i].d + parseInt(this.selectedAction[i].actionList[j].d);
                    }
                    if (this.selectedAction[i].recordType === 1) {
                        this.selectedAction[i].capacity = this.selectedAction[i].capacity + parseInt(this.selectedAction[i].actionList[j].w) * parseInt(this.selectedAction[i].actionList[j].f);
                    }
                    if (this.selectedAction[i].recordType === 2) {
                        this.selectedAction[i].actionList[j].th = this.selectedAction[i].actionList[j].t / 3600 < 10 ? '0' + this.selectedAction[i].actionList[j].t / 3600 : this.selectedAction[i].actionList[j].t / 3600;
                        this.selectedAction[i].actionList[j].tm = this.selectedAction[i].actionList[j].t % 3600 / 60 < 10 ? '0' + this.selectedAction[i].actionList[j].t % 3600 / 60 : this.selectedAction[i].actionList[j].t % 3600 / 60;
                        this.selectedAction[i].actionList[j].ts = this.selectedAction[i].actionList[j].t % 60 < 10 ? '0' + this.selectedAction[i].actionList[j].t % 60 : this.selectedAction[i].actionList[j].t % 60;
                    }
                }
            }
        },
        back() {
            if (this.from == 'web') {
                this.$router.back();
            } else {
                WebJSBridge.call("closeWeb", null, function (res) {
                });
            }
        },
        toActionLibrary() {
            this.$router.push({
                name: 'actionLibrary',
                query: {
                    lang: this.$i18n.locale,
                    currentActionCount: this.selectedAction.length,
                    theme: this.theme,
                }
            });
        },
        changeUnit(item, unit) {
            this.$set(item, 'unit', unit);
            this.$forceUpdate()
        },
        copyGroup(item, group) {
            if (item.actionList.length >= 20) {
                this.$toast({
                    message: this.$t('planEdit.maxTip'),
                    duration: 1000
                })
                return;
            }
            this.$set(item.actionList, item.actionList.length, {
                w: group.w,
                d: group.d,
                f: group.f,
                t: group.t,
                th: group.th,
                tm: group.tm,
                ts: group.ts
            });
            this.$forceUpdate();
            this.countCapacity(item);
        },
        deleteGroup(item, group) {
            const index = item.actionList.indexOf(group);
            if (index !== -1) {
                item.actionList.splice(index, 1);
            }
            if (item.actionList.length == 0) {
                const index = this.selectedAction.indexOf(item);
                if (index !== -1) {
                    this.selectedAction.splice(index, 1);
                }
            } else {
                this.countCapacity(item);
            }
            this.$forceUpdate()
        },
        addGroup(item) {
            if (item.actionList.length >= 20) {
                this.$toast({
                    message: this.$t('planEdit.maxTip'),
                    duration: 1000
                })
                return;
            }
            item.actionList.push({
                w: '',
                f: '',
                d: '',
                th: '00',
                tm: '30',
                ts: '00'
            });
            this.$forceUpdate();
        },
        countCapacity(item) {
            let capacity = 0;
            for (let i = 0; i < item.actionList.length; i++) {
                if (item.actionList[i].w != '' && item.actionList[i].f != '') {
                    capacity += parseInt(item.actionList[i].w) * parseInt(item.actionList[i].f);
                }
            }
            this.$set(item, 'capacity', capacity);
            let totalCapacity = 0;
            for (let i = 0; i < this.selectedAction.length; i++) {
                totalCapacity += this.selectedAction[i].capacity;
            }
            this.$set(this.planDesc, 'totalCapacity', totalCapacity);
            this.$forceUpdate()
        },
        addTrainPlan() {
            if (!this.planDesc.planName) {
                this.$toast(this.$t('planEdit.planNameDesc'));
                return;
            }
            if (this.selectedAction.length == 0) {
                this.$toast(this.$t('planEdit.actionListPlaceholder'));
                return;
            }
            let groupCount = 0;
            let trainParts = [];
            let trainMuscles = [];
            let actionList = [];
            let actionListGroup = [];
            let actionListUnit = [];
            for (let i = 0; i < this.selectedAction.length; i++) {
                actionList.push(this.selectedAction[i].actionId)
                let trainPartsItem = this.selectedAction[i].trainParts.split(',');
                let trainMusclesItem = this.selectedAction[i].trainMuscles.split(',');
                trainParts.push(...trainPartsItem);
                trainMuscles.push(...trainMusclesItem);
                if (this.selectedAction[i].recordType == 1) {
                    actionListUnit.push(this.selectedAction[i].unit)
                } else {
                    actionListUnit.push('0')
                }
                groupCount = groupCount + this.selectedAction[i].actionList.length;
                for (let j = 0; j < this.selectedAction[i].actionList.length; j++) {
                    if (this.selectedAction[i].recordType == 1 && (this.selectedAction[i].actionList[j].w == '' || this.selectedAction[i].actionList[j].f == '' || this.selectedAction[i].actionList[j].f == 0)) {
                        this.$toast(this.$t('planEdit.inputPlaceholder'));
                        return;
                    }
                    this.selectedAction[i].actionList[j].t = parseInt(this.selectedAction[i].actionList[j].th) * 3600 + parseInt(this.selectedAction[i].actionList[j].tm) * 60 + parseInt(this.selectedAction[i].actionList[j].ts);
                    delete this.selectedAction[i].actionList[j].th
                    delete this.selectedAction[i].actionList[j].tm
                    delete this.selectedAction[i].actionList[j].ts
                    if (this.selectedAction[i].recordType == 2 && (this.selectedAction[i].actionList[j].t == '' || this.selectedAction[i].actionList[j].t == 0)) {
                        this.$toast(this.$t('planEdit.inputPlaceholder'));
                        return;
                    }
                    if (this.selectedAction[i].recordType == 3 && (this.selectedAction[i].actionList[j].f == '' || this.selectedAction[i].actionList[j].f == 0)) {
                        this.$toast(this.$t('planEdit.inputPlaceholder'));
                        return;
                    }
                    if (this.selectedAction[i].recordType == 4 && (this.selectedAction[i].actionList[j].d == '' || this.selectedAction[i].actionList[j].d == 0)) {
                        this.$toast(this.$t('planEdit.inputPlaceholder'));
                        return;
                    }
                    this.selectedAction[i].actionList[j].w = parseInt(this.selectedAction[i].actionList[j].w);
                    this.selectedAction[i].actionList[j].f = parseInt(this.selectedAction[i].actionList[j].f);
                    this.selectedAction[i].actionList[j].d = parseInt(this.selectedAction[i].actionList[j].d);
                }
                actionListGroup.push(this.selectedAction[i].actionList)
            }
            trainParts = [...new Set(trainParts)]
            trainMuscles = [...new Set(trainMuscles)]
            this.planDesc.trainParts = trainParts.join(',');
            this.planDesc.trainMuscles = trainMuscles.join(',');
            this.planDesc.actionCount = this.selectedAction.length;
            this.planDesc.groupCount = groupCount;
            if (this.planDesc.actionList) {
                delete this.planDesc.actionList
            }
            this.planDesc.actionListId = actionList.toString();
            this.planDesc.actionListGroup = JSON.stringify(actionListGroup);
            this.planDesc.actionListUnit = actionListUnit.toString();
            this.$api.trainPlan.addTrainPlan(this.planDesc).then(res => {
                if (res.info.planId) {
                    this.$toast(this.$t('planEdit.success'));
                    WebJSBridge.call("planEditSuccess", null, function (res) {
                    });
                    this.planDesc = {
                        planName: '',
                        totalCapacity: 0,
                        actionList: [],
                        actionCount: 0,
                        groupCount: 0
                    }
                    this.selectedAction = [];
                    if (this.planId) {
                        this.$router.back();
                    } else {
                        this.$router.push({
                            name: 'setPlanDate',
                            query: {
                                planId: res.info.planId,
                                from: this.from,
                                lang: this.$i18n.locale,
                                theme: this.theme,
                            }
                        })
                    }
                }
            })
        }
    }
}
</script>

<style scoped>
.save {
    font-size: 15px;
    color: #00BD9B;
    text-align: right;
    margin: 13px 19px;
    line-height: 19px;
}

.green_light {
    color: #92D7B3;
}

.train-name-box {
    width: 345px;
    height: 66px;
    background: var(--bg-color-2);
    border-radius: 13px 13px 13px 13px;
    margin: 0px auto;
}

.content {
    width: 100%;
    margin-top: 98px;
}

.plan-name {
    font-size: 15px;
    color: var(--text-color-2);
    line-height: 66px;
    margin-left: 18px;
}

.plan-name-input-field {
    padding: 21px 0;
}

.plan-name-input {
    width: 150px;
    float: right;
    margin-right: 22px;
}

/deep/ .van-cell {
    background-color: var(--bg-color-2);
}

.action-title {
    font-size: 17px;
    color: var(--text-color-1);
    margin: 23px 0 16px 31px;
    line-height: 17px;
}

.add-icon {
    width: 26px;
    margin-right: 6px;
}

.add-action {
    text-align: center;
    font-size: 15px;
    color: var(--text-color-1);
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 15px;
}

.group-item {
    width: 345px;
    background: var(--bg-color-2);
    border-radius: 13px 13px 13px 13px;
    margin: 0 auto 12px;
}

.active-icon {
    width: 46px;
    margin-left: 18px;
}

.group-top {
    padding-top: 15px;
}

.flex-line {
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.action-name {
    font-size: 17px;
    color: var(--text-color-1);
}

.action-capacity {
    font-size: 12px;
    color: var(--text-color-2);
    margin-right: 22px;
}

.action-num {
    font-size: 12px;
    color: var(--text-color-3);
}

.action-omit {
    color: var(--text-color-2);
    font-size: 24px;
    margin-right: 22px;
}

.add-top-line {
}

.add-title-box {
    width: 100%;
    height: 30px;
    position: relative;
    color: var(--text-color-3);
    font-size: 12px;
}

.add-title-box-ja {
    height: 45px;
}

.group-title {
    position: absolute;
    left: 0;
    top: 6px;
    width: 40px
}

.w-title {
    position: absolute;
    width: 46px;
    text-align: center;
    left: 37px;
    top: 6px;
}

.f-title {
    position: absolute;
    width: 46px;
    text-align: center;
    left: 96px;
    top: 6px;
}

.unit-box {
    width: 52px;
    height: 21px;
    background: var(--bg-color-1);
    border-radius: 7px 7px 7px 7px;
    position: absolute;
    right: 22px;
    top: 4px;
}

.kg-unit {
    width: 26px;
    height: 21px;
    border-radius: 7px 7px 7px 7px;
    position: absolute;
    left: 0;
    text-align: center;
    line-height: 21px;
}

.lbs-unit {
    width: 26px;
    height: 21px;
    border-radius: 7px 7px 7px 7px;
    position: absolute;
    right: 0;
    text-align: center;
    line-height: 21px;
}

.active {
    background: #00BD9B;
    color: var(--bg-color-1);
}

.add-w-input {
    position: absolute;
    left: 37px;
}

.group-input {
    background-color: var(--bg-color-1);
    width: 46px;
    height: 32px;
    border-radius: 8px;
    padding: 4px;
}

.add-line {
    width: 100%;
    position: relative;
    height: 32px;
    padding-bottom: 10px;
}

.add-index {
    font-size: 13px;
    color: var(--text-color-1);
    text-align: center;
    height: 32px;
    line-height: 32px;
    position: absolute;
    left: 0;
}

.add-f-input {
    position: absolute;
    left: 96px;
}

.copy-icon {
    position: absolute;
    left: 200px;
    top: 7px;
    width: 20px;
}

.delete-icon {
    position: absolute;
    left: 228px;
    top: 7px;
    width: 20px;
}

.add-group {
    width: 345px;
    height: 47px;
    border-top: 1px solid var(--bg-color-1);
    color: #00BD9B;
    font-size: 15px;
    line-height: 47px;
    text-align: center;
}

.total-capacity {
    font-size: 12px;
    color: var(--text-color-2);
    float: right;
    margin-right: 22px;
}

.d-unit-box {
    width: 32px;
    height: 21px;
    background: var(--bg-color-1);
    border-radius: 7px 7px 7px 7px;
    font-size: 12px;
    color: var(--text-color-3);
    text-align: center;
    line-height: 21px;
    position: absolute;
    left: 215px;
}

.time-box {
    width: 100%;
    height: 46px;
    position: relative;
    font-size: 12px;
    color: var(--text-color-3);
    padding-top: 10px;
}

.add-time-input {
    display: inline-block;
    margin: 0 8px;
}

.t1 {
    position: absolute;
    left: 37px;
    display: inline-block;
}

.t2 {
    position: absolute;
    left: 93px;
    display: inline-block;
}

.t3 {
    position: absolute;
    left: 149px;
    display: inline-block;
}

.ts1 {
    color: var(--text-color-1);
    position: absolute;
    left: 86px;
    font-size: 13px;
    line-height: 32px;
}

.ts2 {
    color: var(--text-color-1);
    position: absolute;
    left: 141px;
    font-size: 13px;
    line-height: 32px;
}

/deep/ .van-field__control {
    color: var(--text-color-1);
}
</style>


// WEBPACK FOOTER //
// src/views/trainPlan/01planEdit.vue